import React, { useEffect } from "react";
import { Link } from "react-router-dom";

import { Helmet } from "react-helmet";
import FooterFour from "./common/footers/footer-four";
import TopBarDark from "./common/headers/common/topbar-dark";
import "./landing.scss";
import { useSelector } from "react-redux";

const Landing = () => {
  const { user } = useSelector((state) => state.auth);
  console.log("REACT_APP_VAC", process.env.REACT_APP_VAC);
  useEffect(() => {
    window.onscroll = () => {
      const nav = document.querySelector("nav")
      if (nav) {
      if (window.scrollY > 200) {
        nav.style = `
					box-shadow: 0 1px 16px #000;
				`;
      } else {
        nav.style = `
					box-shadow: 0 0 0 #fff;
				`;
      }
    }
    };
    return () => {
      window.onscroll = () => {};
    };
  }, []);
  const toggleNav = (action) => {
    if (action === "open") {
      document.querySelector(".nav-links").style = `
				right: 0;
        display:block;
			`;
    } else {
      document.querySelector(".nav-links").style = `
      @media only screen and (max-width: 1200px) {
        display:none
      }`;
    }
  };
  const scrollIntoView = (el) => (e) => {
    e.preventDefault();
  };
  return (
    <div className="landing-page w-100">
      <TopBarDark />
      <Helmet>
        <title>eksplode! | Home </title>
      </Helmet>

      <header id="home">
        <nav className="">
          <div
            className="container d-flex align-items-center justify-content-between"
            style={{ padding: "0 40px" }}
          >
            {/* Logo */}
            <a
              href="https://c5m.world/"
              target="_blank"
              rel="noopener noreferrer"
              className="d-flex align-items-center"
              style={{ marginRight: "20px" }}
            >
              <img
                src={`${process.env.PUBLIC_URL}/assets/images/c5m.png`}
                alt="c5m logo"
                className="img-fluid"
                style={{ maxHeight: "90px" }}
              />
            </a>
            <div className="menu-icon" onClick={() => toggleNav("open")}>
              <i className="fa fa-bars sidebar-bar" />
            </div>
            <div
              style={{ textAlign: "center" }}
              className="nav-links"
              onClick={() => toggleNav("close")}
            >
              <ul>
                <li className="active">
                  <Link to="/about-us">About Us</Link>
                </li>
                {/* <li className="active">
                  <Link to="/termsofuse">Terms of Use</Link>
                </li>

                <li className="active">
                  <Link to="/privacypolicy">Privacy Policy</Link>
                </li> */}

                <li>
                  <Link to="/vac-rules">The VAC</Link>
                </li>
                <li>
                  <Link to="/dac-rules">The DAC</Link>
                </li>
                <li>
                  <Link to="/fill/consent-form">Parental Consent Forms</Link>
                </li>

                {/* <li>
                  <Link to="/fill/consent-form">Official DAC Rules</Link>
                </li> */}
                {/* <li>
                  <a href="/fill/consent-form">Viewers Club</a>
                </li> */}

                <li>
                  <a href={`${process.env.REACT_APP_GAMING}/register`}>
                    Gamers Club
                  </a>
                </li>

                {user && user?.user?.role === "member" ? (
                  <li>
                    <Link
                      to={`${process.env.PUBLIC_URL}/dashboard/member/account`}
                    >
                      Members Club
                    </Link>
                  </li>
                ) : user && user?.user?.role !== "member" ? (
                  <li>
                    <Link
                      to={`${process.env.PUBLIC_URL}/dashboard/${user?.user?.role}`}
                    >
                      Members Club
                    </Link>
                  </li>
                ) : (
                  <li>
                    <Link to={`${process.env.PUBLIC_URL}/register/member`}>
                      Members Club
                    </Link>
                  </li>
                )}
                <li>
                  <a
                    target="_blank"
                    href={`${process.env.REACT_APP_VAC}/register/star`}
                  >
                    Stars Club
                  </a>
                </li>

                {user && user?.user?.role === "merchant" ? (
                  <li>
                    <Link to={`${process.env.PUBLIC_URL}/dashboard/merchant`}>
                      Retailers Club
                    </Link>
                  </li>
                ) : user && user?.user?.role !== "merchant" ? (
                  <li>
                    <Link
                      to={`${process.env.PUBLIC_URL}/
              `}
                    >
                      Retailers Club
                    </Link>
                  </li>
                ) : (
                  <li>
                    <Link to={`${process.env.PUBLIC_URL}/register/merchant`}>
                      Retailers Club
                    </Link>
                  </li>
                )}

                {/* <li>
                  <a href={`${process.env.REACT_APP_ECODE}/register`}>
                    e-Code Card
                  </a>
                </li> */}
              </ul>
            </div>
          </div>
        </nav>
      </header>
      <main>
        {/* <section> */}
        <div className="container welcome">
          <div className="row">
            <img
              src={`${process.env.PUBLIC_URL}/assets/images/us-flag.png`}
              alt=""
              id="flag"
            />
          </div>
          <div className="row d-flex justify-content-center mt-5">
            <h1>WELCOME TO</h1>
          </div>
          <div className="row d-flex justify-content-center mt-5">
            <img
              src={`${process.env.PUBLIC_URL}/assets/images/icon/logo-eksplode.png`}
              alt=""
              id="big-logo"
              className="img-fluid img-fluid-responsive"
            />
          </div>
          <div className="row d-flex justify-content-center mt-3 text-center">
            <h6>
              Where technology and entertainment collide to bring you the future
              of interactive marketing.
            </h6>
          </div>

          <div className="container">
            <div className="row d-flex flex-column  mt-5 align-items-center text-center ">
              <h5 className="text-muted">
                VIEW homemade commercials and vote for your favorite.
              </h5>
              <h5 className="text-muted">
                PLAY free video games and compete for weekly prizes.{" "}
              </h5>
              <h5 className="text-muted">
                EARN rewards for promoting retail merchandise.
              </h5>
              <h5 className="text-muted">
                CASH in by producing your own amateur commercials.
              </h5>
              <h5 className="text-muted">
                JOIN eksplode! today and receive your own e-Code
              </h5>
              <h5 className="text-muted">
                digital payment card, available to all participants 13 years and
                older.
              </h5>
            </div>
          </div>
        </div>
        {/* </section> */}
        <section>
          <div className="container ">
            <div className="row d-flex flex-column">
              <div className=" d-flex justify-content-center ">
                <h3 style={{ textAlign: "justify" }}>
                  <strong>Retailers and Company Brands</strong>
                </h3>
              </div>
              <div className=" d-flex justify-content-center ">
                <h4 style={{ textAlign: "center" }}>
                  <strong>
                    Sell to a wider customer base through our five-star
                    programs:
                  </strong>
                </h4>
              </div>
              <ul className="d-flex flex-column text-center">
                <li className="text-center">
                  Digital AdverBook program (Adverreading)
                </li>
                <li className="text-center">
                  Electronic Ad Card program (Adversharing)
                </li>
                <li className="text-center">
                  Video Ad Contest program (Advertainment)
                </li>
                <li className="text-center">
                  Video Gaming AdVenture program (Advergaming)
                </li>
                <li className="text-center">
                  eksplode!'s e-Code Digital Payment Card program
                </li>
              </ul>
            </div>

            <div className="row justify-content-center">
              <div className="col-md-5 col-lg-4 ">
                <div className="join-card d-flex flex-column justify-content-center text-center ">
                  <i className="fa fa-video-camera" />

                  <div className="join-card-body mt-3">
                    <h6 classname="mx-2">
                      View amateur commercials and vote for your favorite!
                    </h6>
                  </div>
                  <div className="join-card-action mt-10">
                    <a
                      href={`${process.env.REACT_APP_VAC}/explore`}
                      className="mt-3 btn btn1 "
                    >
                      View
                    </a>
                  </div>
                </div>
              </div>
              <div className="col-md-5 col-lg-4 ">
                <div className="join-card d-flex flex-column justify-content-center text-center ">
                  <i className="fa fa-gamepad" />
                  <div className="join-card-body mt-3">
                    <h6 classname=" mx-2">
                      Play mobile games for a chance to win cash prizes!
                    </h6>
                  </div>
                  <div className="join-card-action mt-10 ">
                    <Link
                      target="_blank"
                      href={`${process.env.REACT_APP_GAMING}/`}
                      className="mt-3 btn btn1"
                    >
                      Play
                    </Link>
                  </div>
                </div>
              </div>

              <div className="col-md-5 col-lg-4 ">
                <div className="join-card d-flex flex-column justify-content-center text-center ">
                  <i className="fa fa-money"></i>

                  <div className="join-card-body mt-3">
                    <h6 classname="mx-2 ">Earn</h6>
                  </div>
                  <div className="join-card-action mt-10 fixed ">
                    <Link
                      target="_blank"
                      href={`${process.env.REACT_APP_VAC}/register/star`}
                      className="mt-3 btn btn1"
                    >
                      EARN
                    </Link>
                  </div>
                </div>
              </div>
              <div className="col-md-5 col-lg-4 ">
                <div className="join-card d-flex flex-column justify-content-center text-center ">
                  <i className="fa fa-money"></i>
                  <div className="join-card-body mt-3">
                    <h6 classname="mx-2 ">Cash</h6>
                  </div>
                  <div className="join-card-action mt-10 fixed ">
                    <Link
                      target="_blank"
                      href={`${process.env.REACT_APP_VAC}/`}
                      className="mt-3 btn btn1"
                    >
                      CASH
                    </Link>
                  </div>
                </div>
              </div>
              <div className="col-md-5 col-lg-4 ">
                <div className="join-card d-flex flex-column justify-content-center text-center ">
                  <i className="fa fa-user" />
                  <div className="join-card-body mt-3">
                    <h6 classname="mx-2 ">
                      Join our free programs and start earning cash today!
                    </h6>
                  </div>
                  <div className="join-card-action mt-10 fixed ">
                    <Link
                      target="_blank"
                      href={`${process.env.REACT_APP_ECODE}/register`}
                      className="mt-3 btn btn1"
                    >
                      JOIN
                    </Link>
                  </div>
                </div>
              </div>
              <div className="col-md-5 col-lg-4 ">
                <div className="join-card d-flex flex-column justify-content-center text-center ">
                  <i className=" fa fa-exchange" />
                  <div className="join-card-body mt-3">
                    <h6 classname="mx-2 ">SELL</h6>
                  </div>
                  <div className="join-card-action mt-10 fixed ">
                    <Link
                      target="_blank"
                      href={`${process.env.PUBLIC_URL}/register/merchant`}
                      className="mt-3 btn btn1"
                    >
                      SELL
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>
      <FooterFour logoName={"logo-eksplode.png"} />
    </div>
  );
};

export default Landing;
